module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_shinjuku-159d791fff316339b0d873143c50650f.webp";